<div class="border-0 p-4">
    <!-- Company First Card with side margins -->
   <div class="company-first-card mb-4 shadow-lg rounded-lg p-2 w-100 position-relative mt-0" :class="{
    'complyon-com-bg':  hostname.includes('aicampus.complyon') ,
     }">
    <section class="hero-section w-100 px-2 py-1 d-flex justify-content-between align-items-start">

      <div class="hero-content p-1 me-md-5 col-md-7 col-lg-6">
        <p class="hero-title text-white text-xl fw-bold">{{ hero_title }}</p>
        <p class="hero-description mt-1 text-white text-x fst-italic">
          {{ hero_description }}
        </p>

      </div>
    </section>

    <!-- ACTION BUTTONS -->
    <div class="d-flex flex-wrap gap-2 w-100 justify-content-end mt-4">

      <!-- CREATE COMPANY -->
      <button
        class="btn-primary-dark btn-sm text-xxs shadow text-dark"
        data-bs-toggle="modal"
        data-bs-target="#create_company"
      >
        <span class="d-none d-md-inline">Create Company</span>
        <span class="d-inline d-md-none">
          <i class="bi bi-plus-circle me-1"></i>
          Company
        </span>
      </button>

      <!-- DEACTIVATED COMPANY -->
      <button
        class="btn-primary-dark btn-sm text-xxs shadow text-dark"
        data-bs-toggle="modal"
        data-bs-target="#activate_projects"
      >
        <span class="d-none d-md-inline">Deactivated Company</span>
        <span class="d-inline d-md-none">
          <i class="bi bi-trash me-1"></i>
          Company
        </span>
      </button>

      <!-- CONFIG -->
      <button
        class="btn-primary-dark btn-sm text-xxs shadow text-white"
        data-bs-toggle="modal"
        data-bs-target="#configure_company_modal"
      >
        <i class="fa-solid fa-gear me-1"></i>
        Settings
      </button>

    </div>
  </div>

  <!-- ================= CONTENT ================= -->
  <div class="glassy-table shadow-sm border-0 rounded-lg p-3 text-xs">

    <!-- SEARCH -->
    <div class="row g-2 align-items-center mb-3">
      <div class="col-12 col-md-6">
        <input
          v-model="search_query"
          type="text"
          class="form-control form-control-sm text-xxs shadow-sm border"
          placeholder="Search Companies..."
          @input="current_page = 1"
        />
      </div>
      <div class="col-12 col-md-6 text-md-end">
        <span class="fw-normal text-dark border px-3 py-2 text-xxs d-block d-md-inline">
          {{ filtered_company_list.length }} Company(s) found
        </span>
      </div>
    </div>

    <!-- ================= DESKTOP TABLE ================= -->
    <!-- ================= DESKTOP TABLE ================= -->
    <div class="table-responsive d-none d-md-block">
      <table class="table table-hover mb-0">
        <thead class="custom-header">
          <tr>
            <th v-for="h in table_headers" :key="h" class="text-xxs ps-3">
              {{ h }}
            </th>
            <th class="text-xxs ps-3">Actions</th>
          </tr>
        </thead>

        <tbody>
        <template v-for="row in paginated_company_list" :key="row.id">

          <!-- MAIN ROW -->
          <tr>
            <!-- DATA -->
            <td v-for="h in table_headers" :key="h" class="text-xxs ps-3">
              {{ row[h] }}

            </td>


            <!-- ACTIONS -->
            <td class="text-end">

              <div class="d-flex ">


                <!-- RIGHT: ALL OTHER BUTTONS -->
                <div class="d-flex gap-1">


                  <button class="btn btn-sm btn-primary-dark"
                          @click="open_company_or_sub_program(row)">
                    View
                  </button>
                <button
                  v-if="!row._is_sub_program"
                  @click="toggle_program_accordion(row.id)"
                  class="btn-sm btn-primary-dark">
                  <i class="bi"
                    :class="expanded_programs[row.id] ? 'bi-chevron-up' : 'bi-chevron-down'">
                  </i>
                </button>


                  <button
                    v-if="!row._is_sub_program"
                    class="btn-sm btn-primary-dark text-xxs"
                    data-bs-toggle="modal"
                    data-bs-target="#create_sub_program_modal"
                    @click="open_create_sub_program(row.id)">
                    Sub-Company
                  </button>

                  <button
                    v-if="!row._is_sub_program"
                    class="btn btn-sm btn-primary-dark text-xxs"
                    data-bs-toggle="modal"
                    data-bs-target="#update_company"
                    @click="prepopulate_update_company_modal(row.id)">
                    Edit
                  </button>

                  <button
                    v-if="!row._is_sub_program"
                    class="btn btn-sm btn-primary-dark text-xxs"
                    @click="deactivate_company(row.id)">
                    Deactivate
                  </button>

                </div>
              </div>
            </td>
          </tr>

          <!-- SUB PROGRAMS -->
          <tr v-if="!row._is_sub_program && expanded_programs[row.id]">
            <td :colspan="table_headers.length + 1" class="ms-4 p-0 border rounded">
              <div class="px-4 py-3 border-top border-bottom">

                <p class="text-xxs text-dark mb-2">
                  Sub Company for : {{ row.Company }}
                </p>

                <div v-if="sub_programs[row.id] && sub_programs[row.id].length > 0">
                  <div v-for="sp in sub_programs[row.id]"
                      :key="sp.id"
                      class="rounded-lg shadow border mb-2 p-3">

                    <div class="d-flex justify-content-between align-items-center">

                      <div>
                        <p class="text-xs fw-bold mb-0">{{ sp.name }}</p>
                        <p class="text-xxs text-dark mb-0" v-if="sp.description">
                          {{ sp.description }}
                        </p>
                        <small class="text-dark text-xxs">
                          Created : {{ format_date_short(sp.date_created) }}
                        </small>
                      </div>

                      <div class="d-flex gap-1">
                        <button class="btn btn-sm btn-primary-dark"
                                @click="redirect_to_sub_program_jobs(sp.id, sp.name, row.id)">
                          View
                        </button>
                        <button class="btn btn-sm btn-primary-dark"
                                data-bs-toggle="modal"
                                data-bs-target="#edit_sub_program_modal"
                                @click="open_edit_sub_program(sp, row.id)">
                          Edit
                        </button>
                        <button class="btn btn-sm btn-primary-dark"
                                @click="delete_sub_program(sp.id, row.id)">
                          Deactivate
                        </button>
                      </div>

                    </div>
                  </div>
                </div>

                <div v-else class="text-center py-3">
                  <p class="text-xxs text-dark mb-0">
                    No sub-Companies yet.
                  </p>
                </div>

              </div>
            </td>
          </tr>

        </template>

        <!-- EMPTY STATE -->
        <tr v-if="!filtered_company_list.length">
          <td :colspan="table_headers.length + 1"
              class="text-center text-muted text-xxs py-4">
            No companies found.
          </td>
        </tr>
      </tbody>
      </table>
    </div>

    <!-- ================= MOBILE CARDS ================= -->
    <div class="d-md-none">
      <div class="row g-3">

        <div v-for="row in paginated_company_list"
             :key="row.id"
             class="col-12">

          <div class="card shadow-sm border-0 rounded-lg p-3">

            <!-- HEADER -->
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div>
                <h6 class="fw-bold text-sm mb-1">
                  <i class="bi bi-building me-1"></i>
                  {{ row.Company }}
                </h6>
                <small class="text-muted">
                  <i class="bi bi-tag me-1"></i>
                  {{ row.Type || 'N/A' }}
                </small>
              </div>

              <span class="status-badge bg-light text-dark text-xxs">
                No: {{ row.id }}
              </span>
            </div>

            <!-- BODY -->
            <div class="mb-2">
              <p class="text-xxs mb-1">
                <i class="bi bi-card-text me-1"></i>
                {{ row.Description || 'No description' }}
              </p>

              <p class="text-xxs mb-0">
                <i class="bi bi-person me-1"></i>
                {{ row["Assigned Administrator"] || '-' }}
              </p>
            </div>

            <!-- ACTIONS -->
            <div class="d-flex flex-wrap gap-2 w-100 justify-content-end mt-3">

              <!-- Expand Sub Companies -->
              <button
                v-if="!row._is_sub_program"
                class="btn-sm btn-primary-dark"
                @click="toggle_program_accordion(row.id)">
                <i class="bi"
                   :class="expanded_programs[row.id] ? 'bi-chevron-up' : 'bi-chevron-down'">
                </i>
              </button>

              <button class="btn-sm btn-primary-dark"
                      @click="open_company_or_sub_program(row)">
                <i class="bi bi-eye"></i>
              </button>

              <button v-if="!row._is_sub_program"
                      class="btn-sm btn-primary-dark"
                      @click="open_create_sub_program(row.id)"
                      data-bs-toggle="modal"
                      data-bs-target="#create_sub_program_modal">
                <i class="bi bi-plus-circle"></i>
              </button>

              <button v-if="!row._is_sub_program"
                      class="btn-sm btn-primary-dark"
                      @click="prepopulate_update_company_modal(row.id)"
                      data-bs-toggle="modal"
                      data-bs-target="#update_company">
                <i class="bi bi-pencil"></i>
              </button>

              <button v-if="!row._is_sub_program"
                      class="btn-sm btn-primary-dark"
                      @click="deactivate_company(row.id)">
                <i class="bi bi-trash"></i>
              </button>

            </div>

            <!-- ================= SUB COMPANIES (MOBILE) ================= -->
            <div v-if="!row._is_sub_program && expanded_programs[row.id]" class="mt-3">

              <p class="text-xs text-dark mb-2 fw-bold mt-3">
                Sub Companies for : {{ row.Company }}
              </p>

              <div v-if="sub_programs[row.id] && sub_programs[row.id].length > 0">

                <div v-for="sp in sub_programs[row.id]"
                     :key="sp.id"
                     class="border rounded p-2 mb-2">

                  <div class="d-flex justify-content-between align-items-start">

                    <div>
                      <p class="text-xs fw-bold mb-1">{{ sp.name }}</p>

                      <p class="text-xxs mb-1" v-if="sp.description">
                        {{ sp.description }}
                      </p>

                      <small class="text-dark text-xxs">
                        Created : {{ format_date_short(sp.date_created) }}
                      </small>
                    </div>

                    <div class="d-flex justify-content-end gap-1 mt-2 mt-auto">

                      <!-- VIEW -->
                      <button
                        class="btn-sm btn-primary-dark"
                        @click="redirect_to_sub_program_jobs(sp.id, sp.name, row.id)"
                        title="View">
                        <i class="bi bi-eye"></i>
                      </button>

                      <!-- EDIT -->
                      <button
                        class="btn-sm btn-primary-dark"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_sub_program_modal"
                        @click="open_edit_sub_program(sp, row.id)"
                        title="Edit">
                        <i class="bi bi-pencil"></i>
                      </button>

                      <!-- DEACTIVATE -->
                      <button
                        class="btn-sm btn-primary-dark"
                        @click="delete_sub_program(sp.id, row.id)"
                        title="Deactivate">
                        <i class="bi bi-trash"></i>
                      </button>

                    </div>

                  </div>

                </div>

              </div>

              <div v-else class="text-center py-2">
                <p class="text-xxs text-muted mb-0">
                  No sub-company yet.
                </p>
              </div>

            </div>

          </div>
        </div>

        <!-- EMPTY STATE -->
        <div v-if="!filtered_company_list.length" class="col-12 text-center">
          <p class="text-muted text-xxs">No companies found.</p>
        </div>

      </div>
    </div>

  </div>

  <!-- PAGINATION -->
  <div v-if="total_pages > 1"
       class="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2 mt-3">

    <button class="btn-sm btn-primary-dark text-xxs"
            @click="current_page--"
            :disabled="current_page === 1">
      <i class="bi bi-chevron-left"></i> Previous
    </button>

    <span class="text-xs text-dark">
      Page {{ current_page }} of {{ total_pages }}
    </span>

    <button class="btn-sm btn-primary-dark text-xxs"
            @click="current_page++"
            :disabled="current_page === total_pages">
      Next <i class="bi bi-chevron-right"></i>
    </button>

  </div>
</div>

<!-- Footer -->
<AICampusFooter/>



<!-- Create Company Modal -->
<teleport to="body">
<div class="modal fade" id="create_company" tabindex="-1" aria-labelledby="create_section_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_project_label">
         Create Company
        </p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label for="company_name" class="modal-form-label form-label text-xxs">
            Company Name:
          </label>
          <input type="text" v-model="company_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            placeholder="Enter Company Name Here" />
          <small class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">Please enter a name for the
            Company</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="company_description" class="modal-form-label form-label text-xxs">
            Company Description:
          </label>
          <input type="text" v-model="company_description"
            class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-xxs"
            placeholder="Enter Company Description Here" />
          <small class="text-danger p-2 text-xxs fw-bold d-none project-description-messages">Please enter a description
            for the Company</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label for="company_type" class="modal-form-label form-label text-xxs">
            Company Type:
          </label>
          <select v-model="selected_company_type" class="modal-form-select form-select text-xxs rounded-small p-2 shadow-sm text-x">
            <option value="" disabled hidden>Select Type</option>
            <option v-for="type in company_types" :key="type.id" :value="type.id">
              {{ type.project_type }}
            </option>
          </select>
          <small class="text-danger p-2 text-xxs fw-bold d-none project-type-messages">Please select a Company
            type</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="create_company">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Assign Users Modal -->
 <teleport to="body">
<div class="modal fade" id="assign_users" tabindex="-1" aria-labelledby="assign_users_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="assign_users_label">Assign Users</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <GlobalTable
          v-if="users_list.length > 0"
          :headers="user_table_headers"
          :data="users_list"
          :key="users_list"
          table_id="user_assignment_table"
        >
          <template #actions="{ row }">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'switch_' + row.user_id"
                :checked="assigned_users.includes(row.user_id)"
                @change="toggle_assignment(row.user_id)"
              >
              <label class="form-check-label" :for="'switch_' + row.user_id">
                {{ assigned_users.includes(row.user_id) ? 'Assigned' : 'Unassigned' }}
              </label>
            </div>
          </template>
        </GlobalTable>
      </div>
    </div>
  </div>
</div>
</teleport>


<!-- Activate projects Modal -->
 <teleport to="body">
<div class="modal fade" id="activate_projects" tabindex="-1" aria-labelledby="activate_projects_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="activate_projects_label">Activate Company</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
         <div class="card shadow-sm border table-border-color rounded-lg p-3 table-responsive text-xs">
            <table id="deactivated_projects_table" class="table table-hover">
                <thead class="custom-header">
                  <tr>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">ID</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Company</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Type</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Assigned Administrator</th>
                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="project in deactivated_projects" :key="project.id">
                    <td class="text-xxs text-start">{{ project.id }}</td>
                    <td class="text-xxs text-start">{{ project.name }}</td>
                    <td class="text-xxs text-start">{{ project.project_description }}</td>
                    <td class="text-xxs text-start">{{ project.project_type?.name || '-' }}</td>
                    <td class="text-xxs text-start">{{ project.creator?.full_name || '-' }}</td>
                    <td class="text-xxs text-start">
                      <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="activate_projects(project.id)">Activate</button>
                    </td>
                  </tr>
                </tbody>
            </table>
          </div>
      </div>
    </div>
  </div>
</div>
</teleport>


<!-- Update Company Modal -->
 <teleport to="body">
<div class="modal fade" id="update_company" tabindex="-1" aria-labelledby="update_company_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="update_company_label">
         Update Company
        </p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="modal-form-group form-group mb-3">
          <label for="update_company_name" class="modal-form-label form-label text-xxs">
            Company Name:
          </label>
          <input type="text" v-model="update_company_name" class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" />
          <small class="text-danger p-2 text-xxs fw-bold d-none update-company-name-messages">Please enter a name for the
            Company</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>

        <div class="modal-form-group form-group mb-3">
          <label for="update_company_description" class="modal-form-label form-label text-xxs">
            Company Description:
          </label>
          <input type="text" v-model="update_company_description"
            class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-xxs"/>
          <small class="text-danger p-2 text-xxs fw-bold d-none update-company-description-messages">Please enter a description
            for the Company</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>

        <div class="modal-form-group form-group mb-3">
          <label for="update_company_type" class="modal-form-label form-label text-xxs">
            Company Type:
          </label>
          <select v-model="update_selected_company_type" class="modal-form-select form-select text-xxs rounded-small p-2 shadow-sm text-x">
            <option value="" disabled hidden>Select Type</option>
            <option v-for="type in company_types" :key="type.id" :value="type.id">
              {{ type.project_type }}
            </option>
          </select>
          <small class="text-danger p-2 text-xxs fw-bold d-none update-company-type-messages">Please select a Company
            type</small>
          <small class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>

      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="update_project">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>


<!-- Create Sub Program Modal -->
<teleport to="body">
<div class="modal fade" id="create_sub_program_modal" tabindex="-1" aria-labelledby="create_sub_program_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_sub_program_label">Create Sub Company</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Sub Company Name:</label>
          <input type="text" v-model="create_sp_name"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            placeholder="Enter Sub-Company name" />
        </div>
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Description (optional):</label>
          <input type="text" v-model="create_sp_description"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            placeholder="Enter description" />
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="create_sub_program">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>


<!-- Edit Sub Program Modal -->
<teleport to="body">
<div class="modal fade" id="edit_sub_program_modal" tabindex="-1" aria-labelledby="edit_sub_program_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="edit_sub_program_label">Edit Sub Company</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Sub Company Name:</label>
          <input type="text" v-model="edit_sp_name"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" />
        </div>
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Description (optional):</label>
          <input type="text" v-model="edit_sp_description"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" />
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="save_edit_sub_program">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>


<teleport to="body">

<div class="modal fade" id="configure_company_modal" tabindex="-1">

  <div class="modal-dialog modal-dialog-centered modal-lg">

    <div class="modal-content bg-white rounded-3 shadow-lg">

      <div class="modal-header cute-header shadow-lg">

        <p class="modal-title text-white text-xxs">
          Select Company For System Configuration
        </p>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal">
        </button>

      </div>

      <div class="modal-body">

        <div class="table-responsive">

          <table class="table table-hover">

            <thead class="custom-header">

              <tr>
                <th class="text-uppercase text-xxs ps-3">Company</th>
                <th class="text-uppercase text-xxs ps-3">Configuration</th>
              </tr>

            </thead>

            <tbody>

              <tr v-for="row in config_table_data" :key="row.id">

                <td class="text-xxs ps-3">
                  {{ row.Company }}
                </td>

                <td class="text-xxs ps-3">

                  <div class="form-check form-switch">

                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'config_switch_' + row.id"
                      :checked="isSelectedProject(row.id)"
                      @change="toggle_config_project(row)"
                    >

                    <label
                      class="form-check-label text-xxs ms-2"
                      :for="'config_switch_' + row.id"
                    >
                      {{ isSelectedProject(row.id) ? "Active" : "Select" }}
                    </label>

                  </div>

                </td>

              </tr>

              <tr v-if="config_table_data.length === 0">
                <td colspan="2" class="text-center text-muted text-xxs">
                  No projects available
                </td>
              </tr>

            </tbody>

          </table>

        </div>

      </div>

    </div>

  </div>

</div>

</teleport>
